import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IGlobalState } from './global-state';
import { StateSlice } from '../state-slice';
import { DatetimeFormat } from '@core/models/common/datetime-format';
import { GlobalSettings } from '@core/models/common/global-settings';
import { Industry } from '@core/models/industry/industry';

export const selectGlobalState = createFeatureSelector<IGlobalState>(StateSlice.GLOBAL);


export const getGlobalState = createSelector(
    selectGlobalState,
    (state: IGlobalState): IGlobalState => state
);

export const getUserDatetimeFormats = createSelector(
    selectGlobalState,
    (state: IGlobalState): DatetimeFormat[] => state.datetimeFormats
);

export const getPositionColors = createSelector(
    selectGlobalState,
    (state: IGlobalState): string[] => state.positionColors
);

export const getPlatforms = createSelector(
    selectGlobalState,
    (state: IGlobalState): { web, ios, android } => state.platforms
);

export const getLocales = createSelector(
    selectGlobalState,
    (state: IGlobalState): { label: string, value: string }[] => state.locales
);

export const getTimezones = createSelector(
    selectGlobalState,
    (state: IGlobalState): any[] => state.timezones
);

export const getCurrencyOptions = createSelector(
    selectGlobalState,
    (state: IGlobalState): any[] => state.currencyOptions
);

export const getFormattedTimezones = createSelector(
    getTimezones,
    (timezones: any[]): any[] => {

        const formatted: any[] = [];
        if (timezones && timezones.length) {
            timezones.forEach((timezone) => {
                const keys: any[] = Object.keys(timezone);
                formatted.push({
                    id: keys[0],
                    label: timezone[keys[0]]
                });
            });
        }
        return formatted;
    }
);

export const getGlobalSettings = createSelector(
    selectGlobalState,
    (state: IGlobalState): GlobalSettings => state.settings
);

export const getIndustryList = createSelector(
    selectGlobalState,
    (state: IGlobalState): Industry[] => state.industries
);

export const getDatetimeOptions = createSelector(
    selectGlobalState,
    (state: IGlobalState): DatetimeFormat[] => state.datetimeFormats
);
